import type { Mode } from './types';

export interface ShareParams {
  mode?: Mode;
  timeSpan?: 'day' | 'week';
  showVPTS?: boolean;
  showVID?: boolean;
  animationStart?: string;
  animationEnd?: string;
  stationIds?: string[];
}

const SHARE_KEYS = ['m', 'ts', 'vpts', 'vid', 'as', 'ae', 'si'] as const;

export function parseShareParams(): ShareParams | null {
  const params = new URLSearchParams(window.location.search);

  const hasAny = SHARE_KEYS.some((key) => params.has(key));
  if (!hasAny) {
    return null;
  }

  const result: ShareParams = {};

  const modeVal = params.get('m');
  if (modeVal === 'density' || modeVal === 'birdtam') {
    result.mode = modeVal;
  }

  const tsVal = params.get('ts');
  if (tsVal === 'day' || tsVal === 'week') {
    result.timeSpan = tsVal;
  }

  const vptsVal = params.get('vpts');
  if (vptsVal === '0' || vptsVal === '1') {
    result.showVPTS = vptsVal === '1';
  }

  const vidVal = params.get('vid');
  if (vidVal === '0' || vidVal === '1') {
    result.showVID = vidVal === '1';
  }

  const asVal = params.get('as');
  if (asVal && !isNaN(new Date(asVal).getTime())) {
    result.animationStart = asVal;
  }

  const aeVal = params.get('ae');
  if (aeVal && !isNaN(new Date(aeVal).getTime())) {
    result.animationEnd = aeVal;
  }

  const siVal = params.get('si');
  if (siVal) {
    const ids = siVal.split(',').filter((id) => id.length > 0);
    if (ids.length > 0) {
      result.stationIds = ids;
    }
  }

  return result;
}

export function buildShareUrl(params: ShareParams): string {
  const searchParams = new URLSearchParams();

  if (params.mode) {
    searchParams.set('m', params.mode);
  }
  if (params.timeSpan) {
    searchParams.set('ts', params.timeSpan);
  }
  if (params.showVPTS !== undefined) {
    searchParams.set('vpts', params.showVPTS ? '1' : '0');
  }
  if (params.showVID !== undefined) {
    searchParams.set('vid', params.showVID ? '1' : '0');
  }
  if (params.animationStart) {
    searchParams.set('as', params.animationStart);
  }
  if (params.animationEnd) {
    searchParams.set('ae', params.animationEnd);
  }
  if (params.stationIds && params.stationIds.length > 0) {
    searchParams.set('si', params.stationIds.join(','));
  }

  const qs = searchParams.toString();
  const { origin, pathname, hash } = window.location;
  return `${origin}${pathname}${qs ? `?${qs}` : ''}${hash}`;
}

export function cleanShareParams(): void {
  const params = new URLSearchParams(window.location.search);
  SHARE_KEYS.forEach((key) => params.delete(key));
  const remaining = params.toString();
  const { pathname, hash } = window.location;
  const newUrl = `${pathname}${remaining ? `?${remaining}` : ''}${hash}`;
  window.history.replaceState(null, '', newUrl);
}
